export const USER_ROLES = {
  SUPER_ADMIN: "superadmin",
  ADMIN: "admin",
  MANAGER: "manager",
  STAFF: "staff",
  SHOP: "shop",
  USER: "user",
  GUEST: "guest",
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];

export const ALL_USER_ROLES: UserRole[] = [
  USER_ROLES.SUPER_ADMIN,
  USER_ROLES.ADMIN,
  USER_ROLES.MANAGER,
  USER_ROLES.STAFF,
  USER_ROLES.SHOP,
  USER_ROLES.USER,
  USER_ROLES.GUEST,
];

export const BUSINESS_MEMBER_ROLES: UserRole[] = [
  USER_ROLES.ADMIN,
  USER_ROLES.MANAGER,
  USER_ROLES.STAFF,
  USER_ROLES.SHOP,
  USER_ROLES.USER,
  USER_ROLES.GUEST,
];

export const normalizeUserRole = (role?: string | null): UserRole => {
  const normalized = String(role || "")
    .trim()
    .toLowerCase()
    .replace(/[_\-\s]/g, "");

  switch (normalized) {
    case "superadmin":
      return USER_ROLES.SUPER_ADMIN;
    case "admin":
      return USER_ROLES.ADMIN;
    case "manager":
      return USER_ROLES.MANAGER;
    case "staff":
      return USER_ROLES.STAFF;
    case "shop":
    case "seller":
      return USER_ROLES.SHOP;
    case "basic":
    case "customer":
    case "user":
      return USER_ROLES.USER;
    default:
      return USER_ROLES.GUEST;
  }
};

export const formatUserRole = (role?: string | null) => {
  const normalized = normalizeUserRole(role);

  if (normalized === USER_ROLES.SUPER_ADMIN) return "Super Admin";

  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};
